import * as React from 'react';
import { SVGProps } from 'react';

const IconPrinterFilledSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2 2a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1H2ZM2 3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h1V6a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3h1a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H2Z" />
    <path d="M8 11H4V6h4v5Z" />
  </svg>
);
export default IconPrinterFilledSizeXs;
